import { API_URL, REPs, API_KEY, POWERLEGO_API_URL, PROVIDER_ID, PROMO_CODE, PAYMENT_TOKEN_URL } from "../config";

export const converArrToSearchParams = (name: string, arr: string[] | number[]) => {
    return arr.map((val, key) => {
        return `${name}[${key}]=${val}`;
    }).join('&');
}

export const getRepIds = () => {
    return REPs.map(val => val.providerId);
}

export const fetchToken = async (firstName: any, lastName: any, email: any) => {
    try {

        const url = `${PAYMENT_TOKEN_URL}`;

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "firstName": firstName,
            "lastName": lastName,
            "email": email,
            "pmCategory": "CC",
            "lang": "en"
        });

        const response = await fetch(url, {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => result)
            .catch(error => console.log('error', error));
        return response
    }
    catch (err) {
        console.error(err);
    }
}

export const paymentusToken = async () => {
    try {

        const url = `https://d2bsfae29grbu.cloudfront.net/paymentus/token`

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const response = await fetch(url, {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => result)
            .catch(error => console.log('error', error));
        return response
    }
    catch (err) {
        console.error(err);
    }
}

export const paydeposite = async (email: string, sign: string, customerID: string, paymentToken: string, enrollmentId: string) => {
    try {
        const url = `${POWERLEGO_API_URL}/v2/constellation/payment`

        const myHeaders = new Headers()
        myHeaders.append('Authorization', `Bearer ${API_KEY}`)

        const formdata = new FormData();
        formdata.append("enrollment_id", enrollmentId);
        formdata.append("email", email);
        formdata.append("sign", sign);
        formdata.append("customer_id", customerID);
        formdata.append("payment_method_token", paymentToken);
        formdata.append("paymentus_type_code", '1');
        formdata.append("source_system_type_id", "1");
        formdata.append("payment_method_id", '0');
        formdata.append("account_number", '1');

        const raw = JSON.stringify({
            "enrollment_id": enrollmentId,
            "email": email,
            "sign": sign,
            "customer_id": customerID,
            "payment_method_id": 0,
            "payment_method_token": paymentToken,
            "paymentus_type_code": 1,
            "source_system_type_id": 1,
        });

        const response = await fetch(url, {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        }).then(response => response.json())
            .then(result => result)
            .catch(error => console.log('error', error));
        return response
    }
    catch (err) {
        console.error(err);
    }
}

export const fetchTerms = async (utilityCode: string) => {
    const hostId = REPs.filter(val => val.host)[0].providerId;

    try {
        const res = await fetch(`${API_URL}/get_contract_terms`,
            {
                method: 'POST',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    'Authorization': `Bearer ${API_KEY}`
                },
                body: `provider_id=${hostId}&utility_code=${utilityCode}`
            }
        )
        return res.json()
    }
    catch (err) {
        console.error(err);
    }
}

export const fetchPlan = async (
    term: number,
    utilityCode: string,
    usages: number[]
) => {
    try {
        let body = `${converArrToSearchParams('provider_ids', getRepIds())}&term=${term}&utility_code=${utilityCode}&${converArrToSearchParams('usages', usages)}`;
        const res = await fetch(`${API_URL}/get_average_price`,
            {
                method: 'POST',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    'Authorization': `Bearer ${API_KEY}`
                },
                body: body
            }
        )
        return res.json()
    }
    catch (err) {
        console.error(err);
    }
}

export const fetchThreeHeightsPlan = async (
    term: number,
    utilityCode: string,
    usages: number[]
) => {
    try {
        const res = await fetch(`${API_URL}/average_price`,
            {
                method: 'POST',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    'Authorization': `Bearer ${API_KEY}`
                },
                body: `provider_id=${PROVIDER_ID}&term=${term}&utility_code=${utilityCode}&${converArrToSearchParams('usages', usages)}&provider_num=999`
            }
        )
        return res.json()
    }
    catch (err) {
        console.error(err);
    }
}

export const fetchUtility = async (zipcode: string) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const formdata = new FormData();
    formdata.append('zipcode', zipcode);

    const url = `${POWERLEGO_API_URL}/v1/get_utility`

    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    })
    return response.json()
}

export const fetchAddress = async (val: string) => {
    const string = val.toString().replace(/#/, '')

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const formdata = new FormData();
    formdata.append("term", string);

    const url = `${POWERLEGO_API_URL}/v1/address_validator`

    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    })
    return response.json()
}

export const fetchEstUsage = async (
    address: string, city: string, state: string, zipcode: string
) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const formdata = new FormData();
    formdata.append("address1", address);
    formdata.append("city", city);
    formdata.append("state", state);
    formdata.append("zipcode", zipcode);

    const url = `${POWERLEGO_API_URL}/v1/usage_estimator`

    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    })
    return response.json()
}

export const fetchPremiseDetail = async (zipcode: string, address: string) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const formdata = new FormData();
    formdata.append("zipcode", zipcode);
    formdata.append("address", address);

    const url = `${POWERLEGO_API_URL}/v2/premise/detail`

    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    })
    return response.json()
}

export const fetchRetailElectricProviders = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const url = `${POWERLEGO_API_URL}/v2/smt/retail_electric_providers`

    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
    })
    return response.json()
}

export const newAgreement = async (
    esiid: string, meterNumber: string, certificateNumber: string, email: string, forwardEmail: string
) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const formdata = new FormData();
    formdata.append("esiid", esiid);
    formdata.append("meter_number", meterNumber);
    formdata.append("certificate_number", certificateNumber);
    formdata.append("email", email);
    formdata.append("email_forward", forwardEmail);

    const url = `${POWERLEGO_API_URL}/v2/smt/new_agreement`

    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    })
    return response.json()
}

export const fetchMonthlyUsage = async (
    esiid: string, consentId: string, startDate: string, endDate: string
) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const formdata = new FormData();
    formdata.append("consent_id", consentId);
    formdata.append("esiid", esiid);
    formdata.append("start_date", startDate);
    formdata.append("end_date", endDate);

    const url = `${POWERLEGO_API_URL}/v2/smt/monthly`

    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    })
    return response.json()
}

export const getAgreement = async (consentId: string) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const formdata = new FormData();
    formdata.append("consent_id", consentId);
    formdata.append("vip", "1");

    const url = `${POWERLEGO_API_URL}/v2/smt/get_agreement`

    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    })
    return response.json()
}

export const fetchRepList = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const url = `${POWERLEGO_API_URL}/v1/rep_list`

    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
    })
    return response.json()
}

export const getMyAccountInfo = async (
    username: string, password: string, rep: string
) => {
    const myHeaders = new Headers();

    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const formdata = new FormData();
    formdata.append("username", username);
    formdata.append("password", password);
    formdata.append("rep", rep);
    formdata.append("method", '0');

    const url = `${POWERLEGO_API_URL}/v1/rep_usage`

    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    })
    return response.json()
}

export const fetchRateCompare = async (tduCode: any, term: any) => {
    let url = `https://bb0xg7o51l.execute-api.us-east-2.amazonaws.com/beta/marketing`;

    const formdata = new FormData();
    formdata.append("utility_code", tduCode);
    formdata.append("term", term);


    const response = await fetch(url, {
        method: 'POST',
        body: formdata
    });

    return response.json()
}


export const fetchPlans = async (zipcode: any, utility_code: any, term: any, provider_id: any, usage: any) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    let url = `${POWERLEGO_API_URL}/v2/enrollment/rate `;

    const formdata = new FormData();
    formdata.append("zipcode", zipcode);
    formdata.append("utility_code", utility_code);
    formdata.append("filter[provider_id][0]", provider_id);
    formdata.append("filter[type]", 'normal');
    formdata.append("filter[term][0]", term);

    for (let index = 0; index < 12; index++) {
        formdata.append(`usage[monthly][${index + 1}]`, usage[index] ? usage[index] : 1000);

    }
    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata
    });

    return response.json()
}

export const fetchConstellationPlans = async (zipcode: any, utility_code: any, term: any, provider_id: any, usage: any, promo_code: string = PROMO_CODE) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    let url = `${POWERLEGO_API_URL}/v2/constellation/products`;

    const formdata = new FormData();
    formdata.append("zipcode", zipcode);
    formdata.append("utility_code", utility_code);
    // formdata.append("filter[provider_id][0]", provider_id);
    formdata.append("filter[type]", 'normal');
    // Need not send term for AC protect offer codes
    if (promo_code === PROMO_CODE) {
        formdata.append("filter[term][0]", term);
    }
    formdata.append("service_type", 'Electric')
    formdata.append("sign_up_type", 'Electric')
    formdata.append("promo_code", promo_code)

    for (let index = 0; index < 12; index++) {
        formdata.append(`usage[monthly][${index + 1}]`, usage[index] ? usage[index] : 1000);

    }
    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata
    });

    return response.json()
}

export const fetchFliterMonth = async (zipcode: string, utility_code: string, promo_code: string = PROMO_CODE) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    let url = `${POWERLEGO_API_URL}/v2/constellation/filter`;

    const formdata = new FormData();
    formdata.append("zipcode", zipcode);
    formdata.append("utility_code", utility_code);
    formdata.append("filter[provider_id][0]", PROVIDER_ID);
    formdata.append("filter[type]", 'normal');
    formdata.append("service_type", 'Electric')
    formdata.append("sign_up_type", 'Electric')
    formdata.append("promo_code", promo_code)

    // for (let index = 0; index < 12; index++) {
    //     formdata.append(`usage[monthly][${index + 1}]`, 1000);

    // }
    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata
    });

    return response.json()
}
export const fetchLocation = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const requestOptions = {
        method: 'GET',
        headers: myHeaders
    };

    const url = `https://www.powerlego.com/ApiGateway/v2/tools/ip2location`

    const response = await fetch(url, requestOptions)
    return response.json()
}
export const fetchZipCode = async (city: string, stateCode: string) => {
    const string = city.toString().replace(/#/, '')


    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${API_KEY}`);

    const formdata = new FormData();
    formdata.append("term", string);

    const url = `${POWERLEGO_API_URL}/v1/address_validator`
    const response = await fetch(url, {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    })

    return response.json();


}